import React from 'react'
import { Link } from 'react-router-dom'
import logoLight from '../assets/images/logo-light-tm.png'

import {
  FiFacebook,
  FiLinkedin,
  FiInstagram,
  FiTwitter,
  FiMail,
  FiPhone,
  FiMapPin
  , FaYoutube
} from '../assets/icons/vander'

export default function Footer () {
  return (
    <>
      <footer className=''>
        <div className='container'>
          <div className='row align-items-start'>
            <div className='col-xl-5 col-lg-4 mb-0 mb-md-4 pb-0 pb-md-2 d-flex flex-column justify-content-center align-items-center text-center'>
              <Link to='/' className='logo-footer d-inline-block'>
                <img src={logoLight} height='60' width='auto' alt='ArogyaVansh Logo' className='mx-auto d-block' />
              </Link>
              <p className='mt-3 mb-0'>
                India's Virtual Genetic Wellness Platform.
              </p>
              <a
                href='https://play.google.com/store/apps/details?id=com.docterz.connect.arogyavansh'
                target='_blank'
                rel='noopener noreferrer'
                className='mt-3 d-inline-block'
              >
                <img
                  src='https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg'
                  alt='Get it on Google Play'
                  width='135'
                  height='42'
                  style={{ height: '42px', width: '135px' }}
                />
              </a>
            </div>

            <div className='col-xl-7 col-lg-8 col-md-12'>
              <div className='row'>
                <div className='col-md-8 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0'>
                  <h5 className='footer-head'>Quick Links</h5>
                  <ul className='list-unstyled footer-list mt-4'>
                    <li>
                      <Link to='/' className='text-foot'>
                        <i className='mdi mdi-chevron-right me-1'></i> Home
                      </Link>
                    </li>
                    <li>
                      <Link to='/aboutus' className='text-foot'>
                        <i className='mdi mdi-chevron-right me-1'></i> Who we are
                      </Link>
                    </li>
                    <li>
                      <Link to='/booking-appointment' className='text-foot'>
                        <i className='mdi mdi-chevron-right me-1'></i> Enquiry
                        Form
                      </Link>
                    </li>
                    <li>
                      <Link to='/contact' className='text-foot'>
                        <i className='mdi mdi-chevron-right me-1'></i> Contact
                      </Link>
                    </li>
                    <li>
                      <Link to='/privacy' className='text-foot'>
                        <i className='mdi mdi-chevron-right me-1'></i> Privacy Policy
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className='col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0'>
                  <h5 className='footer-head'>Contact us</h5>
                  <ul className='list-unstyled footer-list mt-4'>
                    <li className='d-flex align-items-center'>
                      <FiMail className='fea icon-sm text-foot align-middle' />
                      <Link
                        to='mailto:info@arogyavansh.in'
                        className='text-foot ms-2'
                      >
                        info@arogyavansh.in
                      </Link>
                    </li>

                    <li className='d-flex align-items-center'>
                      <FiPhone className='fea icon-sm text-foot align-middle' />
                      <a href='tel:+918735979935' className='text-foot ms-2'>
                        +91 8735979935
                      </a>
                    </li>

                    <li className='d-flex align-items-start'>
                      <FiMapPin className='fea icon-sm text-foot align-middle mt-1 flex-shrink-0' />
                      <div className='ms-2'>
                        <div className='text-foot' style={{ fontSize: '0.9rem', lineHeight: '1.5' }}>
                          208, Sarthak Pulse Mall, Bhaijipura Cross Road,<br />
                          Kudasan, Gandhinagar - 382421
                        </div>
                        {/* Square Google Maps thumbnail */}
                        <iframe
                          title='ArogyaVansh Clinic Location'
                          src='https://maps.google.com/maps?q=208+Sarthak+Pulse+Mall+Bhaijipura+Cross+Road+Kudasan+Gandhinagar+382421&output=embed&z=16'
                          width='160'
                          height='160'
                          style={{ border: 0, borderRadius: '8px', display: 'block', marginTop: '8px' }}
                          loading='lazy'
                          referrerPolicy='no-referrer-when-downgrade'
                          allowFullScreen=''
                        ></iframe>
                        <a
                          href='https://www.google.com/maps/search/?api=1&query=208+Sarthak+Pulse+Mall+Bhaijipura+Cross+Road+Kudasan+Gandhinagar+382421'
                          className='btn btn-sm btn-outline-light mt-2'
                          target='_blank'
                          rel='noopener noreferrer'
                          aria-label='View ArogyaVansh clinic on Google Maps'
                          style={{ fontSize: '0.78rem', padding: '3px 10px' }}
                        >
                          <i className='mdi mdi-map-marker me-1' aria-hidden='true'></i>View on Google Maps
                        </a>
                      </div>
                    </li>
                  </ul>

                  <ul className='list-unstyled social-icon footer-social mb-0 mt-4'>
                    <li className='list-inline-item'>
                      <a href='https://www.facebook.com/share/1A4ybztb4c/' className='rounded-pill' target='_blank' rel='noopener noreferrer' aria-label='Follow ArogyaVansh on Facebook'>
                        <FiFacebook className='fea icon-sm fea-social' aria-hidden='true' />
                      </a>
                    </li>
                    <li className='list-inline-item'>
                      <a href='https://instagram.com/arogyavansh' className='rounded-pill' target='_blank' rel='noopener noreferrer' aria-label='Follow ArogyaVansh on Instagram'>
                        <FiInstagram className='fea icon-sm fea-social' aria-hidden='true' />
                      </a>
                    </li>
                    <li className='list-inline-item'>
                      <a href='https://x.com/arogyavansh?t=BzyRv9OxKfX--z6606WjaQ&s=08' className='rounded-pill' target='_blank' rel='noopener noreferrer' aria-label='Follow ArogyaVansh on X (Twitter)'>
                        <FiTwitter className='fea icon-sm fea-social' aria-hidden='true' />
                      </a>
                    </li>
                    <li className='list-inline-item'>
                      <a href='https://www.linkedin.com/company/arogyavansh' className='rounded-pill' target='_blank' rel='noopener noreferrer' aria-label='Follow ArogyaVansh on LinkedIn'>
                        <FiLinkedin className='fea icon-sm fea-social' aria-hidden='true' />
                      </a>
                    </li>
                    <li className='list-inline-item'>
                      <a href='https://youtube.com/@arogyavansh?si=bqdVj-kwM-7uHrAa' className='rounded-pill' target='_blank' rel='noopener noreferrer' aria-label='Subscribe to ArogyaVansh on YouTube'>
                        <FaYoutube className='fea icon-sm fea-social' aria-hidden='true' />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='container mt-5'>
          <div className='pt-4 footer-bar'>
            <div className='row align-items-center'>
              <div className='col-12 text-center'>
                <p className='mb-0'>
                  {new Date().getFullYear()} © ArogyaVansh Powered by Genognosis Healthcare Private Limited.
                  All rights reserved. Design & Develop with{' '}
                  <i className='mdi mdi-heart text-danger'></i> by{' '}
                  <Link to='https://ideaspoint.in' target='_blank' className='text-reset'>
                    <u>IdeasPoint</u>
                  </Link>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
